import cn from 'classnames'
import { FC, memo, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { Translation } from 'cng-common/features/translations'

import { IS_SHOW_TEXT_COMPLETENESS } from '../../config'
import { IWizardStepsGroup } from '../../models/IWizardStep'
import { CompletenessLabel } from '../completenessLabel/CompletenessLabel'
import { WizardStep } from '../wizardStep/WizardStep'

import styles from './WizardStepGroup.module.scss'

interface WizardStepGroupProps {
  step: IWizardStepsGroup
  activeStepId: Nullable<string>
}

export const WizardStepGroup: FC<WizardStepGroupProps> = memo(({ step, activeStepId }) => {
  /** -------------------- Variables ----------------------- */

  const groupStyle = useMemo(
    () =>
      step.completeness
        ? ({
            //'--group-color': step.color, // feature
            '--group-color': '#333',
          } as React.CSSProperties)
        : undefined,
    [step.completeness]
  )

  const groupClassName = useMemo(
    () =>
      cn(styles.sidebarSteps__groupName, styles.sidebarSteps__group, {
        [styles.sidebarSteps__groupCompleteness]: step.completeness,
      }),
    [step.completeness]
  )

  const isShowCompletenessLabel = useMemo(
    () => IS_SHOW_TEXT_COMPLETENESS && step.completeness,
    [step.completeness]
  )

  /** -------------------- Render ----------------------- */

  return (
    <div>
      <div className={groupClassName} style={groupStyle}>
        <Translation text={step.translationKey} span />
        {isShowCompletenessLabel && <CompletenessLabel completeness={step.completeness} />}
      </div>
      <div className={styles.sidebarSteps}>
        {step.steps.map((stepItem) => {
          return <WizardStep key={stepItem.id} step={stepItem} activeStepId={activeStepId} />
        })}
      </div>
    </div>
  )
})

WizardStepGroup.displayName = 'WizardStepGroup'
